import { Component, OnInit } from '@angular/core';
import { WorkshopDefect } from '../../models/workshop-defect.model';
import { ActivatedRoute } from '@angular/router';
import { WorkshopDefectValidatorService } from '../../validators/workshop-defect-validator.service';
import { WorkshopDefectService } from '../../services/workshop-defect.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-workshop-defects-edit',
    templateUrl: './workshop-defects-edit.component.html',
    styleUrls: ['./workshop-defects-edit.component.scss'],
    standalone: false
})
export class WorkshopDefectsEditComponent implements OnInit {

  defect: WorkshopDefect = new WorkshopDefect();

  isError: boolean = false;
  isServerError: boolean = false;
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute,
    private defectValidator: WorkshopDefectValidatorService,
    private defectService: WorkshopDefectService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadDefect(+params['id']);
    })
  }

  loadDefect(id: number): void {
    this.defectService.getWorkshopDefectById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      if(e.status === 403 || e.status === 401){return e;}
      this.isServerError = true;
      return e;
    }))
    .subscribe((defect: WorkshopDefect) => {
      this.defect = defect;
    })
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if(this.defectValidator.isValid(this.defect)) {
      this.defectService.updateWorkshopDefect(this.defect)
      .pipe(take(1))
      .pipe(catchError((e) => {
        if(e.status === 403 || e.status === 401){return e;}
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        this.isSuccess = true;
      })
    } else {
      this.isError = true;
    }
  }

}
